import confidentialIcon from 'assets/images/confidential-icon-green.svg'
import secureIcon from 'assets/images/secure-icon-yellow.svg'

export const PAGE_NAME = 'Enter the phone number you want to track'
export const SECURE_DATA = [
  { img: confidentialIcon, text: 'onboarding.intro8.confidential' },
  { img: secureIcon, text: 'onboarding.intro8.secure' },
]
